//
//
//
//
//
//
//

let task
export default {
    props: {
        content: {
            type: String
        }
    },
    data () {
        return {
            show: true
        }
    },
    mounted () {
        this.$nextTick(() => {
            task = setTimeout(this.close, 5000)
        })
    },
    beforeDestroy () {
        task && clearTimeout(task)
    },
    methods: {
        close () {
            this.show = false
        }
    }
}
